export default [
  {
    "category": "Database",
    "title": "Database",
    "description": "Collect and store content in collections to use anywhere on your site.",
    "link": "/feature/database",
    "_id": "b90ab81a-90c3-4473-9f86-5ab897522916"
  },
  {
    "category": "Database",
    "title": "Dynamic Pages",
    "description": "Design one page layout to create unlimited pages—each with its own content, URL and SEO.",
    "link": "/feature/dynamic-pages",
    "_id": "b2c70d79-dde9-40ed-a4c4-f14bcd771077"
  },
  {
    "category": "Coding",
    "title": "Node.js Server",
    "description": "Write backend and front-end JavaScript.",
    "link": "/feature/node.js-server",
    "_id": "8514656f-a31f-46d1-962d-5f56a83fb8e3"
  },
  {
    "category": "Database",
    "title": "Connect Elements to Data",
    "description": "Connect site elements to a database—without writing a line of code.",
    "link": "/feature/connect-elements-to-data",
    "_id": "9018de90-a049-45b8-92ab-055bf41a979e"
  },
  {
    "category": "Database",
    "title": "External Database Collections",
    "description": "Add databases or services as virtual collections and use the data in your application.",
    "link": "/feature/external-database-collections",
    "_id": "acdfcde3-daa3-4c45-83e8-c85acbd104b6"
  },
  {
    "category": "Coding",
    "title": "Site Monitoring",
    "description": "Integrate with a third-party logging system to view and track application logs and errors.",
    "link": "/feature/Site-monitoring",
    "_id": "8642b3e6-a4e4-4a76-9a47-bed2d841d0b1"
  },
  {
    "category": "Business",
    "title": "Wix Stores",
    "description": "Enhance the functionality of your Wix Store pages.",
    "link": "/feature/wix-stores",
    "_id": "3dc3a144-fef6-4b09-9e08-a3c33e2043cc"
  },
  {
    "category": "Business",
    "title": "Wix Bookings",
    "description": "Enhance the functionality of your Wix Bookings site.",
    "link": "/feature/wix-bookings",
    "_id": "90d3db0a-b8c3-4318-b4cf-ff75563506a2"
  },
  {
    "category": "Business",
    "title": "Wix CRM",
    "description": "Extend the capabilities of Wix CRM.",
    "link": "/feature/wix-crm",
    "_id": "1ed0162b-f125-47e4-a362-eb72bbc194c3"
  },
  {
    "category": "Business",
    "title": "Wix Pay API",
    "description": "Create new ways to accept payments on your site.",
    "link": "/feature/wix-pay-api",
    "_id": "01d0637a-3ff3-413e-a684-f12af57770ea"
  },
  {
    "category": "Business",
    "title": "Wix Blog",
    "description": "Customize your blog, including your post layouts and feed. ",
    "link": "/feature/wix-blog",
    "_id": "18f0131f-00fa-410b-9e0b-b5ffb5b6b5f2"
  },
  {
    "category": "Database",
    "title": "User Input and Custom Forms",
    "description": "Build custom forms with writeable elements that submit info into a collection.",
    "link": "/feature/custom-forms",
    "_id": "05a124ff-793b-4b74-864d-b4b9aa99c349"
  },
  {
    "category": "Marketing",
    "title": "Marketing Tools and Integrations",
    "description": "Use marketing tools and integrations to get analytics, create heat maps, set up A/B tests and more.",
    "link": "/feature/marketing-tools-and-integrations",
    "_id": "a76efab6-c8b7-4385-8e17-d0e2c361423e"
  },
  {
    "category": "Marketing",
    "title": "Analytics",
    "description": "Create custom events triggered to Google Analytics, Google Tag Manager and Facebook Pixel. ",
    "link": "/feature/analytics",
    "_id": "383c9e52-95c2-44b7-8f6e-a43f5c1d337e"
  },
  {
    "category": "Database",
    "title": "Import and Export Data",
    "description": "Import data from a CSV file into a collection, or export collection data to use elsewhere.",
    "link": "/feature/import-%26-export-data",
    "_id": "91983bbf-d322-41a0-a910-83bc90cf1de0"
  },
  {
    "category": "Coding",
    "title": "Release Manager",
    "description": "Create a release candidate and gradually roll out versions to your site visitors.",
    "link": "/feature/release-manager",
    "_id": "c298bf4e-ca20-48fb-b183-73d0070d888f"
  },
  {
    "category": "Business",
    "title": "Roles and Permissions",
    "description": "Define roles for site visitors and members that determine how they can interact with your site.",
    "link": "/feature/roles-and-permissions",
    "_id": "a1695aec-6b00-4c8b-b234-a2bf28225b6e"
  },
  {
    "category": "Business",
    "title": "Members Area",
    "description": "Let site members upload personal info to create custom profile pages.",
    "link": "/feature/members-area",
    "_id": "eb1dfee3-fab0-4a1d-a17b-8e75a7638b25"
  },
  {
    "category": "Coding",
    "title": "Custom Interactions",
    "description": "Add and code events to site elements to create unique user interactions.",
    "link": "/feature/custom-interactions",
    "_id": "5a05449b-0370-40f3-8d88-cf8509fddb6d"
  },
  {
    "category": "Coding",
    "title": "Wix Editor Element APIs",
    "description": "Write code to control the behavior of site elements.",
    "link": "/feature/wix-element-apis",
    "_id": "77f117ac-8e18-4710-bf15-436e2397a573"
  },
  {
    "category": "Coding",
    "title": "Database APIs",
    "description": "Use Wix Data and Wix Dataset APIs to extend and control data in your collections.",
    "link": "/feature/database-apis",
    "_id": "92dce731-64a3-4996-87cc-acebf0b4fd55"
  },
  {
    "category": "Coding",
    "title": "Web Modules",
    "description": "Call backend functions directly from your client code.",
    "link": "/feature/web-modules",
    "_id": "fb09e3f7-eb87-4e8b-b884-eb0efb9b0626"
  },
  {
    "category": "Coding",
    "title": "HTTP Functions",
    "description": "Write serverless functions to expose the functionality of your site as an API.",
    "link": "/feature/http-functions",
    "_id": "97376ac3-5c09-4d76-8c17-25c3f1bc565e"
  },
  {
    "category": "Coding",
    "title": "Routers",
    "description": "Create custom routing and SEO descriptions for selected web pages.",
    "link": "/feature/routers",
    "_id": "1e1b4d40-7ae9-47b9-847f-2d8f207edf2a"
  },
  {
    "category": "Coding",
    "title": "npm Packages",
    "description": "Install Node packages to work with external JavaScript libraries.",
    "link": "/feature/npm-packages",
    "_id": "0bb6949d-33ec-4a65-876f-b09842724a43"
  },
  {
    "category": "Database",
    "title": "Database Joins",
    "description": "Build relationships between data in collections to create master-detail layouts.",
    "link": "/feature/database-joins",
    "_id": "0b6bd0f6-7e7e-4cc7-800c-3c407b2295ce"
  },
  {
    "category": "Coding",
    "title": "Built-In Online IDE",
    "description": "Make coding more productive using the built-in IDE—equipped with syntax highlighting, code completion and more.",
    "link": "/feature/built-in-online-ide",
    "_id": "c64a92b1-d005-4812-9a96-38012b553a17"
  },
  // {
  //   "category": "Coding",
  //   "title": "Local Development",
  //   "description": "Set up a local environment to work collaboratively using the developer tools you prefer.",
  //   "link": "/feature/local-development",
  //   "_id": "9c5c9942-5c17-43d7-b993-5a01763de1e5"
  // },
  {
    "category": "Coding",
    "title": "Functional Testing",
    "description": "Trigger and test your backend functions straight from the IDE within the Editor.",
    "link": "/feature/functional-testing",
    "_id": "ef121b93-e27e-4eae-9fe1-ae9ed823489e"
  },
  {
    "category": "Marketing",
    "title": "SEO",
    "description": "Customize your site’s SEO settings, including titles, descriptions, metadata and SEO patterns.",
    "link": "/feature/seo",
    "_id": "93460a7f-03b5-44c2-bf01-ab9ef4da4252"
  },
  {
    "category": "Coding",
    "title": "Velo Packages",
    "description": "Install pre-built code packages created by Velo to expand your site’s functionality, faster.",
    "link": "/feature/velo-packages",
    "_id": "3391a882-0f47-40fc-9298-df2c84a45c0a"
  }
]